<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card flat tile id="Top_Scroll">
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>사진촬영 허가신청사항 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="mr-4 ml-4"></v-divider>

        <v-card outlined tile class="ma-4" >
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="CustomInfo.CustomNm" label="이름" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="CustomInfo.Tel" label="전화번호" dense disabled persistent-placeholder></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>


        <v-card outlined tile class="ma-4 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6">
                <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" cLabelEs="촬영기간" :sMinDate="sToday" style="width:100%"/>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="editedItem.cPurpose" :items="zPicPurpose" dense persistent-placeholder>
                  <template v-slot:label>
                    <div>촬영목적<strong class="red--text">*</strong></div>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" dense readonly persistent-placeholder>
                  <template v-slot:label>
                    <div>촬영장소<strong class="red--text">*</strong></div>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="editedItem.cInfo" dense auto-grow rows="1" persistent-placeholder>
                  <template v-slot:label>
                    <div>촬영내용<strong class="red--text">*</strong></div>
                  </template>                
                </v-textarea>
              </v-col>
              <v-col cols="12" class="pb-0">
                보안서약*<br>
                <p class="pl-2 pr-2 text-caption font-weight-bold">
                  상기 신청 내용에 한하여 촬영하고, 반·출입 절차를 준수하겠으며, 회사정보의 무단 반출 등으로 인한
                  <span class="red--text">일체의 책임</span>은
                  <span class="red--text">신청인에게 있음</span>에 동의합니다.
                </p>
              </v-col>
              <v-col cols="12" class="d-flex pt-0 pr-6 mt-n2">
                <v-spacer></v-spacer>
                <v-checkbox dense v-model="bcheckbox" color="black">
                  <template v-slot:label>
                    <div class="black--text">동의함</div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-divider class="ml-4 mr-4"></v-divider>
      </v-card>

      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="grey--text text--darken-3">
            <v-icon class="mr-2">mdi-camera-plus-outline</v-icon>촬영기기
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="AddRow(1)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- 촬영 기기 등록 테이블 -->
          <v-data-table
            :items="zReqPicDeviceInfo"
            :headers="headers"
            :hide-default-footer="true"
          >
            <template v-slot:header.cProductNm="{ }">
              <span>품명<strong class="ml-1 red--text">*</strong></span>
            </template>
            <template v-slot:header.cSerialNum="{ }">
              <span>시리얼넘버<strong class="ml-1 red--text">*</strong></span>
            </template>
            <template v-slot:header.cVolume="{ }">
              <span>용량<strong class="ml-1 red--text">*</strong></span>
            </template>
            <template v-slot:header.cCount="{ }">
              <span>수량(개)<strong class="ml-1 red--text">*</strong></span>
            </template>
            <template v-slot:item.cProductNm="{ item }">
              <v-text-field v-model="item.cProductNm"></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum"></v-text-field>
            </template>
            <template v-slot:item.cVolume="{ item }">
              <v-text-field v-model="item.cVolume"></v-text-field>
            </template>
            <template v-slot:item.cCount="{ item }">
              <v-text-field v-model="item.cCount"></v-text-field>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(1,item)" color="black">mdi-close</v-icon>
            </template>
            <!-- <template v-slot:item.cProductNm="{ item }">
              <v-text-field v-model="item.cProductNm"></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum"></v-text-field>
            </template>
            <template v-slot:item.cVolume="{ item }">
              <v-text-field v-model="item.cVolume"></v-text-field>
            </template>
            <template v-slot:item.cCount="{ item }">
              <v-text-field v-model="item.cCount"></v-text-field>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(1,item)" color="black">mdi-close</v-icon>
            </template> -->
            <template v-slot:no-data>
              <div class="black--text">촬영기기를 등록하여 주세요</div>
            </template>
          </v-data-table>
        </v-card-text>


        <v-divider class="ml-4 mr-4"></v-divider>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="grey--text text--darken-3">
            <v-icon class="mr-2">mdi-content-save-outline</v-icon>저장매체
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="AddRow(2)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
        </v-toolbar>
        <v-card-text align="center">
          <!-- 저장매체 등록 테이블 -->
          <v-data-table
            :items="zReqPicSaveInfo"
            :headers="headers1"
            :hide-default-footer="true"
          >
            <template v-slot:item.cProductNm="{ item }">
              <v-text-field v-model="item.cProductNm"></v-text-field>
            </template>
            <template v-slot:item.cSerialNum="{ item }">
              <v-text-field v-model="item.cSerialNum"></v-text-field>
            </template>
            <template v-slot:item.cVolume="{ item }">
              <v-text-field v-model="item.cVolume"></v-text-field>
            </template>
            <template v-slot:item.cCount="{ item }">
              <v-text-field v-model="item.cCount"></v-text-field>
            </template>
            <template v-slot:item.cDel="{ item }">
              <v-icon @click="DelRow(2,item)" color="black">mdi-close</v-icon>
            </template>
            <template v-slot:no-data>
              <div class="black--text">저장매체를 등록하여 주세요</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider class="ml-4 mr-4"></v-divider>
        <v-card-text align="right" class="pa-3">
          <v-btn @click="dialog = false;" text width="90px" class="mr-2"><v-icon class="mr-2">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="SetPhotoPerLog()" dark width="90px" class="ml-2"><v-icon class="mr-2">save</v-icon>저장</v-btn>
        </v-card-text>
      </v-card>
      </v-dialog>
    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
  </div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";
import IronDate from '@/components/iron28Calendar/src/IronDate5.vue';/* 달력 한개 표시 컴퍼넌트 */
import Util from "../Util.js";

import MapDialog from "./MapDialog.vue";

export default {
  components: {
    IronDate,
    MapDialog
  },

  data: () => ({
    sToday : Util.sFormatDate(Date()),
    dialog : false,
    bcheckbox : false,
    EditIndex : -1,
    editedItem : {
      iPhotoPerId : "",
      cCustomNm : "",
      cUserId : "",
      cUserNm : "",
      cPurpose : "",
      cZone    : "",
      cInfo    : "",
      cLocal   : "",
      cCorpNmKor : "",
      cCorpNmEng : "",
      sNowSelectDate :  Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      cStartDate : Util.sFormatDate(Date()),
      cEndDate : Util.sFormatDate(Util.sTomorrowSel()),
    },
    zReqPicDeviceInfo : [],
    zReqPicSaveInfo : [],
    zMapZoneInfo : [],
    headers: [
      // { text: '품명 *', align: 'start', value: 'cProductNm',},
      // { text: '시리얼넘버 *', value: 'cSerialNum',},
      // { text: '용량 *', value: 'cVolume',},
      // { text: '수량(개) *', value: 'cCount',},
      // { text: '삭제', value: 'cDel',},
      { text: '품명 *', align: 'start', value: 'cProductNm',sortable : false},
      { text: '시리얼넘버 *', value: 'cSerialNum',sortable : false},
      { text: '용량 *', value: 'cVolume',sortable : false},
      { text: '수량(개) *', value: 'cCount',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],
    headers1: [
      { text: '품명', align: 'start', value: 'cProductNm',sortable : false},
      { text: '시리얼넘버', value: 'cSerialNum',sortable : false},
      { text: '용량', value: 'cVolume',sortable : false},
      { text: '수량(개)', value: 'cCount',sortable : false},
      { text: '삭제', value: 'cDel',sortable : false},
    ],

  }),
  computed: {
    ...mapState(["CustomInfo","zPicPurpose","zPicZone"]),
  },
  methods: {
    // 맵선택 다이올로그창 열기
    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },

    // 맵선택 후 정보 가져오기
    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },


    // 다이올로그 창열렸을때
    ShowDialog(item,index,Device,Save,Zone){
      this.dialog = true;
      this.EditIndex = index;
      this.bcheckbox = false;

      this.editedItem.cNum = item.cNum
      this.editedItem.iPhotoPerId = item.iPhotoPerId
      this.editedItem.cCustomNm = item.cCustomNm
      this.editedItem.cUserId = item.cUserId
      this.editedItem.cUserNm = item.cUserNm
      this.editedItem.cPurpose = item.cPurpose
      this.editedItem.cZone = item.cZone
      this.editedItem.cLocal = item.cLocal
      this.editedItem.cCorpNmKor = item.cCorpNmKor
      this.editedItem.cCorpNmEng = item.cCorpNmEng
      this.editedItem.cInfo = item.cInfo
      this.editedItem.cStartDate = Util.sFormatDate(item.cStartDate)
      this.editedItem.cEndDate = Util.sFormatDate(item.cEndDate)
      this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " + this.editedItem.cEndDate

      this.zReqPicDeviceInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      this.zReqPicSaveInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});

      this.zReqPicDeviceInfo = Device
      this.zReqPicSaveInfo = Save

      this.zMapZoneInfo = [];
      for (let i =0; i < Zone.length; i ++){
        this.zMapZoneInfo.push(Zone[i].cId)
      }
      setTimeout(() => {
        var element =  document.getElementById("Top_Scroll");
        element.scrollIntoView({behavior : "smooth"})
      }, 10);      
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.cStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.cEndDate = Util.sFormatDate(daterange.endDate);      
      this.editedItem.sNowSelectDate = this.editedItem.cStartDate + " ~ " +  this.editedItem.cEndDate;           
    },

    // 열 추가하기
    AddRow(state) {
      if (state == 1){
        this.zReqPicDeviceInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      } else {
        this.zReqPicSaveInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      }
    },

    // 열 삭제하기
    DelRow(state,row) {
      if (state == 1){
        let iDelIndex1 = this.zReqPicDeviceInfo.indexOf(row);
        if (iDelIndex1 != -1) {  
          this.zReqPicDeviceInfo.splice(iDelIndex1, 1);
        }
      } else {
        let iDelIndex2 = this.zReqPicSaveInfo.indexOf(row);
        if (iDelIndex2 != -1) {  
          this.zReqPicSaveInfo.splice(iDelIndex2, 1);
        }
      }
    },

    // 사진촬영 허가 수정하기
    SetPhotoPerLog(){
      if (this.bcheckbox == false){
        EventBus.$emit("onShowMsgBox","보안서약에 대한 동의가 필요합니다.",  "보안서약을 읽고 동의하기 버튼을 클릭해 주세요.");
        return
      }
      if (this.editedItem.cPurpose == ""){
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "촬영 목적을 입력하여 주세요.");
        return
      }
      if (this.editedItem.cInfo == ""){
        EventBus.$emit("onShowMsgBox","필수 입력사항이 누락되었습니다.",  "촬영 내용을 입력하여 주세요.");
        return
      }
      if (this.editedItem.cZone.length == 0){
        EventBus.$emit("onShowMsgBox","필수 선택사항이 누락되었습니다.",  "촬영 장소를 선택하여 주세요.");
        return
      }

      if (this.zReqPicDeviceInfo.length == 0){
        EventBus.$emit("onShowMsgBox","촬영장치에 대한 정보가 누락되었습니다.","촬영장치를 추가하여 주세요.");
        return
      }

      for (let i=0; i < this.zReqPicDeviceInfo.length; i++) {
        if (this.zReqPicDeviceInfo[i].cProductNm == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 품명 항목이 누락되었습니다.",  "품명 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cSerialNum == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 시리얼 넘버 항목이 누락되었습니다.",  "시리얼 넘버 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cVolume == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 용량 항목이 누락되었습니다.",  "용량 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cCount == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 수량(개) 항목이 누락되었습니다.",  "수량(개) 항목을 입력하여 주세요.");
          return
        }
      }

      var posData = {
        PhotoPerId : this.editedItem.iPhotoPerId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        CustomNm : this.editedItem.cCustomNm,
        UserNm : this.editedItem.cUserNm,
        StartDate : this.editedItem.cStartDate,
        EndDate : this.editedItem.cEndDate,
        Purpose : this.editedItem.cPurpose,
        Info : this.editedItem.cInfo,
        Zone : this.editedItem.cZone,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        ReqPicDeviceInfo : this.zReqPicDeviceInfo,
        ReqPicSaveInfo : this.zReqPicSaveInfo,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "SetPhotoPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd == "00") {
            this.dialog = false;
            this.$emit("ChangePicReq",this.editedItem,this.EditIndex)
            EventBus.$emit("onShowMsg",false,  "사진촬영 허가 요청이 완료되었습니다.");
          } else if (res.data.ResultCd == "02") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "초기화 버튼을 눌러서 상태를 확인해 주세요.");
            this.dialog = false;
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>
